var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles)},[_c('div',{staticClass:"xs-container"},[_vm._t("default"),_vm._t("pulldown"),_vm._t("pullup")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }